"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
const react_1 = __importDefault(require("react"));
const TableCell = ({ column, row }) => (react_1.default.createElement("td", { key: `cell-${column.accessor}` }, column.Cell ? column.Cell({ original: row }) : row[column.accessor]));
exports.TableCell = TableCell;
